import React from "react";
import cx from "classnames";
import { uniqueId } from "lodash";
import { CUSTOMER_DATA } from "data/pages";

import * as styles from "./SpotlightList.module.scss";
import SpotlightItem from "../SpotlightItem";
import { Spotlight } from "types";

interface SpotlightProps {
  theme?: "dark" | "light";
  spotlights: Spotlight[];
}

const SpotlightList: React.FC<SpotlightProps> = ({ theme, spotlights }) => {
  return (
    <section
      className={cx(styles.SpotlightList, {
        [styles.SpotlightList_theme_light]: theme === "light",
      })}
    >
      <div className={styles.SpotlightList_container}>
        <header className={styles.SpotlightList_header}>
          <h2 className={styles.SpotlightList_header_title}>
            Our business spotlight
          </h2>
          <p className={styles.SpotlightList_header_body}>
            Learn from some of our customers making impacts through their work
            in their community every day.
          </p>
        </header>
        <div className={styles.SpotlightList_content}>
          {spotlights.map((spotlight) => (
            <SpotlightItem {...spotlight} key={uniqueId("spotlight-item")} />
          ))}
        </div>
      </div>
    </section>
  );
};

SpotlightList.defaultProps = {
  theme: "dark",
};

export default SpotlightList;
